import React from 'react';
import { useIntl } from 'react-intl';
import { RANGE_ERROR_MESSAGES } from '../utils/messageKeys';
import { clockToInstant, formatClipLength, formatClock } from '../utils/timeZone';
import { StatusMessage } from './StatusMessage';

const TimeField = ({ edge, ms, window, timeZone, onSetTime }) => {
  const { formatMessage } = useIntl();
  const labelId = edge === 'start' ? 'requestVideo_range_from' : 'requestVideo_range_to';

  const handleChange = (event) => {
    const next = clockToInstant(event.target.value, window.start, timeZone);
    if (next !== null) onSetTime(edge, next);
  };

  return (
    <label className="request-video-time-field">
      <span className="input-normal-label">{formatMessage({ id: labelId })}</span>
      <input
        className="input-normal"
        type="time"
        step="1"
        value={formatClock(ms, timeZone, true)}
        onChange={handleChange}
      />
    </label>
  );
};

export const RangeControls = ({ range, window, timeZone, error, rangeActions }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="request-video-range">
      <div className="request-video-fields">
        <TimeField edge="start" ms={range.start} window={window} timeZone={timeZone} onSetTime={rangeActions.setEdge} />
        <TimeField edge="end" ms={range.end} window={window} timeZone={timeZone} onSetTime={rangeActions.setEdge} />
        <span className="request-video-duration">
          {formatMessage(
            { id: 'requestVideo_range_duration' },
            { value: formatClipLength(range.end - range.start) }
          )}
        </span>
      </div>
      {RANGE_ERROR_MESSAGES[error] && <StatusMessage id={RANGE_ERROR_MESSAGES[error]} tone="error" />}
    </div>
  );
};
